import { differenceInDays, intlFormatDistance } from "date-fns";

export let formatDateCalendar = (value: string) => {
    if (!value) return;

    let days = {
        0: 'segunda',
        1: 'terça',
        2: 'quarta',
        3: 'quinta',
        4: 'sexta',
        5: 'sábado',
        6: 'domingo',

    }
    let n = value?.split('/');
    let nF = `${n[2]}-${n[1]}-${n[0]}`;

    //@ts-ignore
    let day = days[(getDay(new Date(nF)))];
    let dia = differenceInDays(new Date(nF), new Date());

    if (dia === 0) return 'Hoje';
    if (dia === -1) return 'Ontem';
    if (dia === -2) return 'Anteontem';
    //@ts-ignore
    if (dia === -3) return `Ultim${day?.slice(-1) === 'o' ? 'o ' : 'a '} ${day}`;
    //@ts-ignore
    if (dia === -4) return `Ultim${day?.slice(-1) === 'o' ? 'o ' : 'a '} ${day}`;
    //@ts-ignore
    if (dia === -5) return `Ultim${day?.slice(-1) === 'o' ? 'o ' : 'a '} ${day}`;
    //@ts-ignore
    if (dia === -6) return `Ultim${day?.slice(-1) === 'o' ? 'o ' : 'a '} ${day}`;
    else return value;
}

export const formatDateDistance = (date: Date) => {
    return intlFormatDistance(new Date(date), new Date())
}

export const differenceDays = (date: Date) => {
    return differenceInDays(new Date(date), new Date())
}

/**
 * 
 * @param dt Exemplo: 01/01/2000
 */
export const convertStringToDate = (dt: string) => {
    let d = dt.split('/');
    let fD = `${d[2]}-${d[1]}-${d[0]}`;
    return new Date(fD);
}

/**
 * 
 * @param dt Exemplo: 01/01/2000
 */
export const convertToStringDate = (dt: string) => {
    let d = dt.split('/');
    return `${d[2]}-${d[1]}-${d[0]}`;
}


export const getDataToDB = (dt: Date) => {
    let date = new Date(dt);

    let dia = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let mes = date.getMonth() < 10 ? '0' + date.getMonth() : date.getDate();
    let ano = date.getFullYear();
    return dia + '/' + mes + '/' + ano;
}

export const parseStringToData = (dt: string) => {
    //@ts-ignore
    let newD = new Date(parseFloat(dt?.split('-')[0]), parseFloat(dt?.split('-')[1]), parseFloat(dt?.split('-')[2]))
    return newD;
}